var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 10C9.54076 10 9.69973 9.93415 9.81694 9.81694C9.93415 9.69973 10 9.54076 10 9.375V5.625C10 5.45924 9.93415 5.30027 9.81694 5.18306C9.69973 5.06585 9.54076 5 9.375 5H5.625C5.45924 5 5.30027 5.06585 5.18306 5.18306C5.06585 5.30027 5 5.45924 5 5.625V9.375C5 9.54076 5.06585 9.69973 5.18306 9.81694C5.30027 9.93415 5.45924 10 5.625 10H9.375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 10H3.75V5C3.75 4.66848 3.8817 4.35054 4.11612 4.11612C4.35054 3.8817 4.66848 3.75 5 3.75H10V3.125C10 2.79348 9.8683 2.47554 9.63388 2.24112C9.39946 2.0067 9.08152 1.875 8.75 1.875H3.125C2.79348 1.875 2.47554 2.0067 2.24112 2.24112C2.0067 2.47554 1.875 2.79348 1.875 3.125V8.75C1.875 9.08152 2.0067 9.39946 2.24112 9.63388C2.47554 9.8683 2.79348 10 3.125 10ZM5 11.875C5 12.2065 5.1317 12.5245 5.36612 12.7589C5.60054 12.9933 5.91848 13.125 6.25 13.125H11.875C12.2065 13.125 12.5245 12.9933 12.7589 12.7589C12.9933 12.5245 13.125 12.2065 13.125 11.875V6.25C13.125 5.91848 12.9933 5.60054 12.7589 5.36612C12.5245 5.1317 12.2065 5 11.875 5H11.25V10C11.25 10.3315 11.1183 10.6495 10.8839 10.8839C10.6495 11.1183 10.3315 11.25 10 11.25H5V11.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit);
export default __webpack_public_path__ + "static/media/unit.d1cc761f31798a690873d509425c9ad4.svg";
export { ForwardRef as ReactComponent };